import React, {FC} from "react"
import styled, {css} from "styled-components"
import PropTypes from "prop-types"

import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {RouterLink} from "@irati/ui/src/Link"
import Flex from "@irati/ui/src/Flex"
import {H3} from "@irati/ui/src/Typography"
import FormattedMessage, {FormattedCurrency} from "@irati/utils/lang"
import {RedemptionReportDuration} from "@irati/types/generated/ops"
import {useUserSavings} from "@irati/adminReporting/hooks"

import {Separator, StyledMenu} from "../WalletMenu/Menu"

const MySavings: FC = (_, {apps}) => {
  const {data} = useUserSavings({duration: RedemptionReportDuration.Last_12Months})
  const savings = data?.savings?.total

  return (
    <RouterLink to="/" app={apps.MY_SAVINGS} plain>
      <StyledMenu>
        <Icon icon={IconTypes.piggyBank} size={28} />
        <Separator />
        <Flex direction="column">
          <CustomHeader>
            <FormattedMessage id="platform.mySavings.headerWidget.copy" />
          </CustomHeader>
          <H3 as="span" marginTop={-0.5}>
            <FormattedCurrency currency={savings?.currency || ""} value={savings?.value || 0} />
          </H3>
        </Flex>
      </StyledMenu>
    </RouterLink>
  )
}

MySavings.contextTypes = {
  apps: PropTypes.object.isRequired
}

export default MySavings

const CustomHeader = styled.span`
  ${({theme}) => css`
    font-family: ${theme.font.bold};
    font-size: 8px;
    text-transform: uppercase;
    color: ${theme.colors.greys.black};
  `}
`
